"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHA512_NODE_ALGO = exports.SHA512_BROWSER_ALGO = exports.SHA256_NODE_ALGO = exports.SHA256_BROWSER_ALGO = exports.RIPEMD160_NODE_ALGO = exports.PREFIX_LENGTH = exports.MAC_LENGTH = exports.KEY_LENGTH = exports.IV_LENGTH = exports.HMAC_NODE_ALGO = exports.HMAC_LENGTH = exports.HMAC_BROWSER_ALGO = exports.HMAC_BROWSER = exports.AES_NODE_ALGO = exports.AES_LENGTH = exports.AES_BROWSER_ALGO = void 0;

var _length = require("./length");

var AES_LENGTH = _length.LENGTH_256;
exports.AES_LENGTH = AES_LENGTH;
var HMAC_LENGTH = _length.LENGTH_256;
exports.HMAC_LENGTH = HMAC_LENGTH;
var AES_BROWSER_ALGO = "AES-CBC";
exports.AES_BROWSER_ALGO = AES_BROWSER_ALGO;
var HMAC_BROWSER_ALGO = "SHA-".concat(AES_LENGTH);
exports.HMAC_BROWSER_ALGO = HMAC_BROWSER_ALGO;
var HMAC_BROWSER = "HMAC";
exports.HMAC_BROWSER = HMAC_BROWSER;
var SHA256_BROWSER_ALGO = "SHA-256";
exports.SHA256_BROWSER_ALGO = SHA256_BROWSER_ALGO;
var SHA512_BROWSER_ALGO = "SHA-512";
exports.SHA512_BROWSER_ALGO = SHA512_BROWSER_ALGO;
var AES_NODE_ALGO = "aes-".concat(AES_LENGTH, "-cbc");
exports.AES_NODE_ALGO = AES_NODE_ALGO;
var HMAC_NODE_ALGO = "sha".concat(HMAC_LENGTH);
exports.HMAC_NODE_ALGO = HMAC_NODE_ALGO;
var SHA256_NODE_ALGO = "sha256";
exports.SHA256_NODE_ALGO = SHA256_NODE_ALGO;
var SHA512_NODE_ALGO = "sha512";
exports.SHA512_NODE_ALGO = SHA512_NODE_ALGO;
var RIPEMD160_NODE_ALGO = "ripemd160";
exports.RIPEMD160_NODE_ALGO = RIPEMD160_NODE_ALGO;
var PREFIX_LENGTH = _length.LENGTH_1;
exports.PREFIX_LENGTH = PREFIX_LENGTH;
var KEY_LENGTH = _length.LENGTH_32;
exports.KEY_LENGTH = KEY_LENGTH;
var IV_LENGTH = _length.LENGTH_16;
exports.IV_LENGTH = IV_LENGTH;
var MAC_LENGTH = _length.LENGTH_32;
exports.MAC_LENGTH = MAC_LENGTH;